import { PropsWithChildren, ReactElement } from "react";
import styles from "./Thumbnail.module.less";
import { setTrackingId } from "client/Misc/utils";

export type ThumbnailProps = {
	trackingId: string;
};

export const Thumbnail = (props: PropsWithChildren<ThumbnailProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{children}
		</div>
	);
};
Thumbnail.displayName = "Thumbnail";